import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';

const CampaignUploadCsv = props => {
  const [selectedFiles, setSelectedFile] = useState([]);
  const dispatch = useDispatch();

  const changeHandler = event => {
    setSelectedFile(event.target.files);
    props.uploadToForm({
      ...props.formData,
      audienceSummaryCSV: event.target.files,
    });
  };

  useEffect(() => {}, [selectedFiles]);

  function dropHandler(ev) {

    ev.preventDefault();
    ev.stopPropagation();

    let files = ev.dataTransfer.files;

    props.uploadToForm({
      ...props.formData,
      audienceSummaryCSV: files,
    });
  }

  const dragOverHandler = ev => {
    ev.preventDefault();
  };

  return (
    <div
      style={uploadCsvStyle.uploadContent}
      id="drop_zone"
      onDrop={event => dropHandler(event)}
      onDragOver={event => dragOverHandler(event)}
    >
      <CloudUploadOutlinedIcon fontSize="large" style={{ fill: '#FF856D' }} />
      <div style={uploadCsvStyle.uploadTitle}>Upload Audience (CSV)</div>
      <div style={uploadCsvStyle.uploadText}>Drag and drop file here or</div>
      <input
        type="file"
        id="files"
        style={{ display: 'none' }}
        onChange={changeHandler}
      />
      <label htmlFor="files" style={uploadCsvStyle.uploadBtn}>
        Choose file
      </label>
    </div>
  );
};

export default CampaignUploadCsv;

const uploadCsvStyle = {
  uploadContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  uploadTitle: {
    fontWeight: 500,
    color: ' #080045',
    marginTop: 15,
  },
  uploadText: {
    color: '#6B7280',
    fontWeight: 500,
    margin: 5,
  },
  uploadBtn: {
    background: '#FFFFFF',
    border: '1px solid #D1D5DB',
    borderRadius: '34.6154px',
    color: '#6B7280',
    padding: '4.1154px 17.3077px',
    margin: 5,
    cursor: 'pointer',
  },
};
